// extracted by mini-css-extract-plugin
export default {"cover_img":"ToonCommonSub_cover_img__A3L-D"};